var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEEZ_PSP_UI_Icons",
    transform: "translate(-153.000000, -156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON-/-STATUS-/-Refus\\xE9",
    transform: "translate(149.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.5 C16.0609173,4.5 19.3680175,7.73557554 19.4961464,11.7577455 L19.5,12 C19.5,16.0609173 16.2644245,19.3680175 12.2422545,19.4961464 L12,19.5 C7.85786438,19.5 4.5,16.1337072 4.5,12 C4.5,7.93908272 7.73557554,4.63198248 11.7577455,4.50385357 L12,4.5 Z M14.6447368,8.25 L12,10.8947368 L9.35526316,8.25 L8.25,9.35526316 L10.8947368,12 L8.25,14.6447368 L9.35526316,15.75 L12,13.1052632 L14.6447368,15.75 L15.75,14.6447368 L13.1052632,12 L15.75,9.35526316 L14.6447368,8.25 Z",
    id: "Combined-Shape",
    fill: "#E64444"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon_cross.ea76f8cb.svg";
export { ForwardRef as ReactComponent };